import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import './Dashboard.css';

const TYPE_LABELS = {
  'start-stop-continue': 'Start · Stop · Continue',
  'mad-sad-glad': 'Mad · Sad · Glad',
  '4ls': '4 Ls',
};

export default function Dashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user === null) navigate('/');
  }, [user, navigate]);

  useEffect(() => {
    if (!user) return;
    fetch('/api/sessions')
      .then((r) => r.json())
      .then((data) => setSessions(Array.isArray(data) ? data : []))
      .finally(() => setLoading(false));
  }, [user]);

  async function handleLogout() {
    await logout();
    navigate('/');
  }

  if (user === undefined) return null;

  return (
    <div className="dash">
      <header className="dash-header">
        <Link to="/" className="dash-logo">retrospekt</Link>
        <div className="dash-user">
          {user?.picture && <img src={user.picture} alt="" className="dash-avatar" />}
          <span className="dash-name">{user?.name}</span>
          <button className="dash-logout" onClick={handleLogout}>Sign out</button>
        </div>
      </header>

      <main className="dash-main">
        <div className="dash-top">
          <h1 className="dash-title">My Retrospectives</h1>
          <Link to="/" className="dash-new-btn">+ New retro</Link>
        </div>

        {loading ? (
          <p className="dash-loading">Loading…</p>
        ) : sessions.length === 0 ? (
          <div className="dash-empty">
            <p>You haven't created any retros yet.</p>
            <Link to="/" className="dash-new-btn">Create your first retro</Link>
          </div>
        ) : (
          <div className="dash-grid">
            {sessions.map((s) => (
              <Link key={s.id} to={`/retro/${s.id}`} className="dash-card">
                <div className="dash-card-header">
                  <span className="dash-card-type">{TYPE_LABELS[s.type] ?? s.type}</span>
                  <span className="dash-card-date">{formatDate(s.createdAt)}</span>
                </div>
                <h2 className="dash-card-name">{s.name}</h2>
                <div className="dash-card-stats">
                  <span className="dash-stat">
                    <span className="dash-stat-value">{s.participantCount}</span> participants
                  </span>
                  <span className="dash-stat">
                    <span className="dash-stat-value">{s.cardCount}</span> cards
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

function formatDate(iso) {
  return new Date(iso).toLocaleDateString(undefined, {
    day: 'numeric', month: 'short', year: 'numeric',
  });
}
